import { AuthProvider } from "contexts/authContext";
import { RoutesComponent } from "./routes";
import { NotificationsProvider } from "contexts/notificationContext";
import { CustomAlert } from "components/CustomAlert";
import { SidebarProvider } from "contexts/sidebarContext";

function App() {
	return (
		<NotificationsProvider>
			<AuthProvider>
				<SidebarProvider>
					<CustomAlert />
					<RoutesComponent />
				</SidebarProvider>
			</AuthProvider>
		</NotificationsProvider>
	);
}

export default App;
